import {styled} from "@mui/material/styles";

export const ContactName = styled("span")({
  color: "#333739",
});

export const ContactInfo = styled("span")({
  color: "#9A9A9A",
});
